export const CENTRE = 'centre'
export const ID = 'id'
export const SLUG = 'slug'
export const CATEGORY = 'category'
export const TEMPLATE_PATH = 'templatePath'
export const LEGACYIDENTIFIER = 'legacyIdentifier'
export const ENTRYID = 'entryId'
export const PRODUCT_ID = 'productId'
export const DATE = 'date'
export const STORE_CAT = 'storeCat'
export const STORE_SUBCAT = 'storeSubCat'

export const TERMS_AND_CONDITIONS = '/terms-and-conditions'
export const PRIVACY_POLICY = '/privacy-policy'
export const FREE_WIFI = `/free-wifi`
export const PRODUCTS = '/products'
export const GIFT_CARDS = '/gift-cards'

export const BROWSE_STORES = `/:${CENTRE}/browse-stores`
export const BROWSE_STORES_WITH_CAT = `/:${CENTRE}/browse-stores/:${STORE_CAT}/:${STORE_SUBCAT}`
export const OPENING_HOURS = `/:${CENTRE}/opening-hours`
export const CENTRE_MAP = `/:${CENTRE}/centre-map/:${LEGACYIDENTIFIER}?/:${SLUG}?`
export const PARKING = `/:${CENTRE}/parking`
export const STORE = `/:${CENTRE}/store/:${ID}/:${SLUG}`
export const WHATS_HAPPENING = `/:${CENTRE}/whats-happening/:${CATEGORY}?`
export const EVENT = `/:${CENTRE}/event/:${ID}/:${SLUG}`
export const NEWS = `/:${CENTRE}/news/:${ID}/:${SLUG}`
export const OFFER = `/:${CENTRE}/offer/:${ID}/:${SLUG}`
export const STORY = `/:${CENTRE}/story/:${ID}/:${SLUG}`
export const SERVICE = `/:${CENTRE}/service/:${ID}/:${SLUG}`
export const MOVIES = `/:${CENTRE}/movies`
export const MOVIE_DETAILS = `/:${CENTRE}/movie/:${ID}/:${SLUG}/:${DATE}?`
export const TEMPLATE = `/:${CENTRE}/:${TEMPLATE_PATH}`
export const DINING = `/:${CENTRE}/dining`
